module.exports = __webpack_public_path__ + "img/captcha-inactive-icon.3d9f12e7.svg";